import {
  BusinessEntitlementConfig,
  EntitlementName,
} from "@shared/types/localTypes/entitlements.ts";
import { entitlementsService } from "@shared/services/entitlements.ts";
import { requestJasTrial } from "@shared/utils/jasTrialRequestUtil.ts";

const entitlement: BusinessEntitlementConfig = {
  entitlementName: EntitlementName.BUSINESS_SECURITY_ADVANCED_USERS,
  displayName: "Advanced Security",
  isCustomerFacing: true,
  displayOrder: 5,
  cardConfig: {
    isTrial: (subscription) =>
      !!subscription.meta.hasJasTrial && !subscription.meta?.isTrial,
    expirationDate: (subscription) =>
      entitlementsService.getEntitlement(
        subscription,
        EntitlementName.BUSINESS_SECURITY_ADVANCED_USERS,
      )?.endDate,
    icon: "curation-icon",
    title: "Advanced Security",
    displayEmptyState: true,
    valueTransformer: (value, hasJasTrial) => {
      const userQty = hasJasTrial
        ? "Unlimited"
        : Number(value).toLocaleString("en-US");
      return `${userQty} Users`;
    },
    valueTransformerSH: (value) => {
      return {
        display: value !== "N/A",
        value: Number(value).toLocaleString("en-US"),
        units: "Users",
      };
    },
    setMeUp: async (requestJasTrialParams) => {
      await requestJasTrial(requestJasTrialParams);
    },
  },
};

export default entitlement;
